var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneMobilePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7852 4.81772C7.13185 4.45773 7.60818 4.25 8.11111 4.25H15.8889C16.3918 4.25 16.8681 4.45773 17.2148 4.81772C17.5605 5.17675 17.75 5.65786 17.75 6.15385V18.8462C17.75 19.3421 17.5605 19.8233 17.2148 20.1823C16.8681 20.5423 16.3918 20.75 15.8889 20.75H8.11111C7.60818 20.75 7.13185 20.5423 6.7852 20.1823C6.43947 19.8233 6.25 19.3421 6.25 18.8462V6.15385C6.25 5.65786 6.43947 5.17675 6.7852 4.81772ZM8.11111 5.75C8.02467 5.75 7.93577 5.7854 7.86568 5.85819C7.79466 5.93194 7.75 6.0378 7.75 6.15385V18.8462C7.75 18.9622 7.79466 19.0681 7.86568 19.1418C7.93577 19.2146 8.02467 19.25 8.11111 19.25H15.8889C15.9753 19.25 16.0642 19.2146 16.1343 19.1418C16.2053 19.0681 16.25 18.9622 16.25 18.8462V6.15385C16.25 6.0378 16.2053 5.93194 16.1343 5.85819C16.0642 5.7854 15.9753 5.75 15.8889 5.75H8.11111Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 16C10.25 15.5858 10.5858 15.25 11 15.25H13C13.4142 15.25 13.75 15.5858 13.75 16C13.75 16.4142 13.4142 16.75 13 16.75H11C10.5858 16.75 10.25 16.4142 10.25 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMobilePhone);
export default __webpack_public_path__ + "static/media/Phone Mobile Phone.6f11aacc89aea97d5e2c5324c0e357ba.svg";
export { ForwardRef as ReactComponent };